<template>
	<v-container fluid>
		<app-head :title="title" />

		<breadcrumbs :breadcrumbs="breadcrumbs" />

		<v-row>
			<v-col>
				<header id="page-header" class="align-center">
					<div class="mr-auto" v-if="title">
						<h1 id="page-title" v-text="title" />
						<div v-if="subtitle" id="page-subtitle">
							<small>{{ subtitle }}</small>
						</div>
					</div>

					<div v-if="hasSlot('actions')" id="page-actions">
						<slot name="actions" />
					</div>
				</header>
			</v-col>
		</v-row>

		<div v-if="hasSlot('before')" id="page-before" class="mb-4">
			<slot name="before" />
		</div>

		<div id="page-body">
			<slot />
		</div>
	</v-container>
</template>
<script>
import AppHead from '@/Shared/AppHead'
import Breadcrumbs from '@/Pages/Backend/Components/Breadcrumbs'

export default {
	components: { AppHead, Breadcrumbs },
	props: {
		title: {
			type: String,
			default: '',
			required: true
		},
		subtitle: {
			type: String,
			default: null
		},
		noBody: {
			type: Boolean,
			default: false,
			required: false
		},
		breadcrumbs: {
			type: Array,
			default: () => [],
			required: false
		}
	},
	data () {
		return {
			//
		}
	},
	computed: {
		//
	},
	methods: {
		hasSlot (name = 'default') {
			return !!this.$slots[ name ] || !!this.$scopedSlots[ name ]
		}
	}
}
</script>
